import { replace } from 'react-router-redux';

import apiCompleteFindPollingStation from '../../utils/findPollingStation/findPollingStationApi';

import { EMAIL_COLLECTED, onFinishMultiAction } from '../Widget/actions';

export const FIND_POLLING_STATION_INITIATED = 'FIND_POLLING_STATION_INITIATED';
export const FIND_POLLING_STATION_SUBMITTING = 'FIND_POLLING_STATION_SUBMITTING';
export const FIND_POLLING_STATION_ERROR = 'FIND_POLLING_STATION_ERROR';
export const FIND_POLLING_STATION_COMPLETED = 'FIND_POLLING_STATION_COMPLETED';
export const FIND_POLLING_STATION_CANCELED = 'FIND_POLLING_STATION_CANCELED';
export const SHOW_ADDRESS_LOOKUP_POPUP = 'SHOW_ADDRESS_LOOKUP_POPUP';
export const FIND_POLLING_STATION_MAP_LOADED = 'FIND_POLLING_STATION_MAP_LOADED';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';

let toasterTimeout = null;

export const onShowAddressPopup = (value, actionIdentifier) => dispatch => {
    dispatch({
        type: SHOW_ADDRESS_LOOKUP_POPUP,
        payload: value
    });

    dispatch({
        type: FIND_POLLING_STATION_INITIATED,
        payload: actionIdentifier
    });

    if (!value) {
        dispatch({
            type: FIND_POLLING_STATION_CANCELED,
            payload: actionIdentifier
        });
    }
};

export const submitFindPollingStationForm = (
    apiRequestData,
    values,
    isMultiActionsCard,
    actionIdentifier,
    actionCompletedTime
) => dispatch => {
    dispatch({
        type: FIND_POLLING_STATION_SUBMITTING,
        payload: { isAddressSubmitting: true }
    });

    apiCompleteFindPollingStation(apiRequestData, values, actionCompletedTime)
        .then(data => {
            if (isMultiActionsCard) {
                onFinishMultiAction(actionIdentifier)(dispatch);
            } else {
                dispatch(replace('/findPollingStation/success'));
            }

            dispatch({
                type: FIND_POLLING_STATION_SUBMITTING,
                payload: { isAddressSubmitting: false }
            });

            dispatch({
                type: SET_SUCCESS_INFO,
                payload: { actionIdentifier }
            });

            dispatch({
                type: FIND_POLLING_STATION_COMPLETED,
                payload: {
                    ...data,
                    actionIdentifier
                }
            });

            if (values.getUpdates) {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });
            }
        })
        .catch(data => {
            let errorMessage;
            if (data.message) {
                errorMessage =
                    'An error has occured. ' +
                    (data.modelState !== undefined
                        ? Object.values(data.modelState)[0].toString()
                        : 'Please try again later!');
            } else {
                errorMessage =
                    'There was an error while submitting your form! Please try again later!';
            }

            dispatch({
                type: FIND_POLLING_STATION_ERROR,
                payload: errorMessage
            });

            if (toasterTimeout != null) {
                clearTimeout(toasterTimeout);
                toasterTimeout = null;
            }

            toasterTimeout = setTimeout(() => {
                toasterTimeout = null;
                dispatch({
                    type: FIND_POLLING_STATION_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: FIND_POLLING_STATION_SUBMITTING,
                payload: { isAddressSubmitting: false }
            });
        });
};

export const googleMapLoad = () => dispatch => {
    dispatch({
        type: FIND_POLLING_STATION_MAP_LOADED,
        payload: true
    });
};
